export enum UserInviteScopeLevelEnum {
    Tenant = 'TENANT',
    Workspace = 'WORKSPACE',
    Board = 'BOARD',
}

export interface InviteMultipleUserToScopeByEmailRequest {
    inviteeEmails: string[];
    scopeLevel: UserInviteScopeLevelEnum;
    scopeId: string;
}

export interface AddUserViewModel {
    id?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    password?: string;
    userName?: string;
    phoneNumber?: string;
    roleName?: string;
    tenantId?: string;
    companyName?: string;
    applicationId?: string;
    active?: boolean;
    confirmPassword?: string;
}

export enum UserInvitaionStatusEnum {
    ACCEPTED = 'ACCEPTED',
    INVITED = 'INVITED',
}

export interface UserInviteStatusModel<T> {
    status?: string;
    user: T;
}

export interface IdValueModel {
    id: string;
    value: string;
}
